(function () {
  const SECTION_SELECTOR = '[id*="__ag_product_reviews"]';
  const INITIAL_VISIBLE_REVIEWS = 2;
  const REVIEWS_PER_CLICK = 3;

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function createElement(tagName, className, text) {
    const element = document.createElement(tagName);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function parseNumber(value) {
    const parsed = Number.parseFloat(String(value || '').replace(',', '.').replace(/[^0-9.]/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getRating(review) {
    const fullStars = review.querySelectorAll('.full-star').length;
    if (fullStars) return Math.min(fullStars, 5);

    const ratingBox = review.querySelector('.rating-box');
    const accessibleRating = ratingBox?.getAttribute('aria-label') || ratingBox?.textContent;
    const parsed = parseNumber(accessibleRating);
    return parsed > 0 ? Math.min(Math.round(parsed), 5) : 0;
  }

  function getReviewData(review) {
    const author = cleanText(review.querySelector('.author > span:not(.time)')?.textContent) || 'Client vérifié';
    const timing = cleanText(review.querySelector('.author .time')?.textContent);
    const content = cleanText(review.querySelector('.reviewTxt > p')?.textContent);
    const reply = cleanText(review.querySelector('.reponse')?.textContent);

    return {
      author,
      timing,
      content,
      reply,
      rating: getRating(review),
    };
  }

  function getDistribution(widget, totalReviews) {
    const distribution = [];

    widget.querySelectorAll('.steavisgarantisStats .item').forEach((item) => {
      const label = cleanText(item.querySelector('.name')?.textContent);
      const stars = Math.round(parseNumber(label));
      const count = Math.round(parseNumber(item.querySelector('.value')?.textContent));

      if (stars >= 1 && stars <= 5) distribution.push({ stars, count });
    });

    const byStars = new Map(distribution.map((entry) => [entry.stars, entry.count]));
    return [5, 4, 3, 2, 1].map((stars) => ({
      stars,
      count: byStars.get(stars) || 0,
      percentage: totalReviews ? Math.round(((byStars.get(stars) || 0) / totalReviews) * 100) : 0,
    }));
  }

  function createStars(rating) {
    const stars = createElement('div', 'ml-product-reviews__stars');
    stars.setAttribute('aria-label', `${rating} étoile${rating > 1 ? 's' : ''} sur 5`);
    stars.textContent = `${'★'.repeat(rating)}${'☆'.repeat(Math.max(0, 5 - rating))}`;
    return stars;
  }

  function createReviewCard(reviewData) {
    const card = createElement('article', 'ml-product-reviews__card');
    const top = createElement('div', 'ml-product-reviews__card-top');
    const identity = createElement('div', 'ml-product-reviews__identity');
    const avatar = createElement('span', 'ml-product-reviews__avatar', reviewData.author.charAt(0).toUpperCase());
    avatar.setAttribute('aria-hidden', 'true');

    const authorBlock = createElement('div', 'ml-product-reviews__author-block');
    authorBlock.append(createElement('strong', 'ml-product-reviews__author', reviewData.author));
    if (reviewData.timing) authorBlock.append(createElement('span', 'ml-product-reviews__date', reviewData.timing));
    identity.append(avatar, authorBlock);
    top.append(identity, createStars(reviewData.rating));
    card.append(top);

    if (reviewData.content) card.append(createElement('p', 'ml-product-reviews__text', reviewData.content));

    if (reviewData.reply) {
      const reply = createElement('div', 'ml-product-reviews__reply');
      reply.append(createElement('strong', '', 'Réponse de Merci Léonie'));
      reply.append(createElement('p', '', reviewData.reply));
      card.append(reply);
    }

    return card;
  }

  function createEditorialWidget(widget, reviewNodes) {
    const reviews = reviewNodes.map(getReviewData).filter((review) => review.content || review.author);
    if (!reviews.length) return null;

    const totalReviews = reviews.length;
    const displayedAverage = cleanText(widget.querySelector('.largeNote big')?.textContent);
    const calculatedAverage = reviews.reduce((sum, review) => sum + review.rating, 0) / totalReviews;
    const average = displayedAverage || calculatedAverage.toFixed(1).replace('.', ',');
    const distribution = getDistribution(widget, totalReviews);
    const certificateLink = widget.querySelector('.certificateBtn');

    const root = createElement('section', 'ml-product-reviews');
    root.setAttribute('aria-labelledby', 'ml-product-reviews-title');

    const header = createElement('header', 'ml-product-reviews__header');
    header.append(createElement('p', 'ml-product-reviews__eyebrow', 'VOS MOTS DOUX'));
    const title = createElement('h2', 'ml-product-reviews__title', 'Ce que vous en pensez');
    title.id = 'ml-product-reviews-title';
    header.append(title, createElement('p', 'ml-product-reviews__intro', 'Des avis authentiques laissés après achat.'));
    root.append(header);

    const summary = createElement('div', 'ml-product-reviews__summary');
    const score = createElement('div', 'ml-product-reviews__score');
    score.append(createElement('strong', 'ml-product-reviews__average', `${average}/5`));
    score.append(createStars(Math.max(0, Math.min(5, Math.round(parseNumber(average))))));
    score.append(createElement('span', 'ml-product-reviews__count', `Basé sur ${totalReviews} avis`));

    const bars = createElement('div', 'ml-product-reviews__bars');
    distribution.forEach((entry) => {
      const row = createElement('div', 'ml-product-reviews__bar-row');
      row.append(createElement('span', 'ml-product-reviews__bar-label', `${entry.stars} ★`));
      const track = createElement('span', 'ml-product-reviews__bar-track');
      const fill = createElement('span', 'ml-product-reviews__bar-fill');
      fill.style.width = `${entry.percentage}%`;
      track.append(fill);
      row.append(track, createElement('span', 'ml-product-reviews__bar-count', String(entry.count)));
      bars.append(row);
    });

    const trust = createElement('div', 'ml-product-reviews__trust');
    trust.append(createElement('span', 'ml-product-reviews__trust-icon', '✓'));
    const trustCopy = createElement('div', 'ml-product-reviews__trust-copy');
    trustCopy.append(createElement('strong', '', 'Avis contrôlés'));
    trustCopy.append(createElement('span', '', 'par Société des Avis Garantis'));
    if (certificateLink?.href) {
      const link = createElement('a', 'ml-product-reviews__certificate', "Voir l’attestation");
      link.href = certificateLink.href;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      trustCopy.append(link);
    }
    trust.append(trustCopy);
    summary.append(score, bars, trust);
    root.append(summary);

    const list = createElement('div', 'ml-product-reviews__list');
    const cards = reviews.map(createReviewCard);
    cards.forEach((card) => list.append(card));
    root.append(list);

    if (cards.length > INITIAL_VISIBLE_REVIEWS) {
      const actions = createElement('div', 'ml-product-reviews__actions');
      const status = createElement('span', 'ml-product-reviews__status');
      const button = createElement('button', 'ml-product-reviews__more', 'Afficher plus d’avis');
      button.type = 'button';
      let visibleCount = INITIAL_VISIBLE_REVIEWS;

      const updateVisibility = () => {
        cards.forEach((card, index) => {
          card.hidden = index >= visibleCount;
        });
        const currentlyVisible = Math.min(visibleCount, cards.length);
        status.textContent = `${currentlyVisible} avis affichés sur ${cards.length}`;
        button.hidden = currentlyVisible >= cards.length;
      };

      button.addEventListener('click', () => {
        visibleCount += REVIEWS_PER_CLICK;
        updateVisibility();
      });

      actions.append(status, button);
      root.append(actions);
      updateVisibility();
    }

    return root;
  }

  function enhanceSection(section) {
    if (section.dataset.mlProductReviewsReady === 'true') return;

    const widget = section.querySelector('#agWidgetMain');
    const reviewNodes = widget ? Array.from(widget.querySelectorAll('.reviewList > li')) : [];

    if (!widget || !reviewNodes.length) {
      section.hidden = true;
      section.dataset.mlProductReviewsReady = 'true';
      return;
    }

    try {
      const editorialWidget = createEditorialWidget(widget, reviewNodes);
      if (!editorialWidget) return;

      widget.insertAdjacentElement('beforebegin', editorialWidget);
      widget.hidden = true;
      widget.setAttribute('aria-hidden', 'true');
      section.classList.add('ml-product-reviews-section');
      section.dataset.mlProductReviewsReady = 'true';
    } catch (error) {
      console.warn('Merci Léonie : le nouvel affichage des avis n’a pas pu être chargé.', error);
    }
  }

  function initialiseReviews() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(enhanceSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseReviews, { once: true });
  } else {
    initialiseReviews();
  }

  document.addEventListener('shopify:section:load', initialiseReviews);
})();
